module.exports = __webpack_public_path__ + "media/תוף.727eb212.mp3";